export default "__VITE_ASSET__COYe9vu1__"